import { AUTOMATION_CONNECTIONS } from '../constants/organizationsKeys';
import variables from '../contexts/ThemeProvider/variables';
import { AutomationStatusEnum, IAutomatedConnection } from '../types/automations';
import { IOrganizationOptions } from '../types/organizations';

export const getAutomationStatusLabel = (status: string, text: string): { message: string; color: string } => {
  switch (status) {
    case AutomationStatusEnum.Active:
      return { message: `${text} is active`, color: variables.budgetGreen };
    case AutomationStatusEnum.Failed:
      return { message: `${text} is failed`, color: variables.errorRed };
    case AutomationStatusEnum.NotActive:
      return { message: `${text} is deactivated`, color: variables.orangeSun };
    default:
      return { message: 'Status is pending', color: variables.grayEbony };
  }
};

export const omitConnectionToken = <T extends Partial<IAutomatedConnection>>({ token, ...connection }: T) => connection;

// Merge.dev tokens are write-only: a token that comes with the organization options is never kept in the store,
// which is persisted to localStorage.
export const stripAutomationConnectionTokens = <T extends IOrganizationOptions | null | undefined>(options: T): T => {
  const connections = options?.[AUTOMATION_CONNECTIONS];

  if (!options || !connections) {
    return options;
  }

  return {
    ...options,
    [AUTOMATION_CONNECTIONS]: connections.map(omitConnectionToken),
  };
};
